import type { IconNode } from '../types';

/**
 * @name cross-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHg9IjIiIHk9IjIiIHJ4PSIzIiAvPgogIDxwYXRoIGQ9Ik0xNCAxMFY3YzAtLjYtLjQtMS0xLTFoLTJjLS42IDAtMSAuNC0xIDF2M0g3Yy0uNiAwLTEgLjQtMSAxdjJjMCAuNi40IDEgMSAxaDN2M2MwIC42LjQgMSAxIDFoMmMuNiAwIDEtLjQgMS0xdi0zaDNjLjYgMCAxLS40IDEtMXYtMmMwLS42LS40LTEtMS0xWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/cross-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const crossSquare: IconNode = [
  ['rect', { width: '20', height: '20', x: '2', y: '2', rx: '3', key: '8x0k8i' }],
  [
    'path',
    {
      d: 'M14 10V7c0-.6-.4-1-1-1h-2c-.6 0-1 .4-1 1v3H7c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h3v3c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-3h3c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1Z',
      key: '184z3d',
    },
  ],
];

export default crossSquare;
